import { render } from "./DialogContent.vue?vue&type=template&id=6e13c560&ts=true"
import script from "./DialogContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogContent.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/dialog/DialogContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e13c560"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e13c560', __exports__)) {
    api.reload('6e13c560', __exports__)
  }
  
  module.hot.accept("./DialogContent.vue?vue&type=template&id=6e13c560&ts=true", () => {
    api.rerender('6e13c560', render)
  })

}


export default __exports__